import React, { useContext, useEffect, useState } from "react";
import './styles.scss';
import { Checkbox, CheckboxProps, Col, Form, Input, InputNumber, Modal, notification, Row, Select, Button,   Radio, Tooltip, RadioChangeEvent  } from "antd";
import { TransfersSuppliersProps, toolpipsOptions } from "./types";
import {  useGetAllAccount } from "../../../Services/useGetAllAccount";
import { OperationTypeProps, useOperations } from "../../../Services/useOperations";
import { useAccounts } from "../../../Services/useAccounts";
import {  VariablesContext } from "../../../Contexts/UserContext/VariablesContext";
import { UserContext } from "../../../Contexts/UserContext/UsersContext";
import { AllClientsProps, useGetAllClients } from "../../../Services/useGetAllClients";
import { CurrencyProps, useGetCurrency } from "../../../Services/useGetCurrency";
import { useGetOperationType } from "../../../Services/useGetOperationType";
import { Transaction } from "../../../Services/useGetMovements";
import ModalTitle from "../../ModalTitle";
import { OperationsContext } from "../../../Contexts/UserContext/OperationsContext";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons" 
import NewCustomer from "../../NewCustomer";
import { useForm } from "antd/es/form/Form";
import DepositExtractionForm from "../DepositExtractionForm";
import { OperationDataInSuppliers } from "../DepositExtractionForm/types";
import { useGetCashDesk } from "../../../Services/useGetCashDesk";

export interface FilterValues{
    value: string,
    label: string,
    key: number,
}

export interface ValuesForm {
    operation_type: FilterValues,
    origin_account: FilterValues,
    destination_account: FilterValues,
    ammount: number,
    approved: boolean,
    description: string,
    supplier: FilterValues,
    supplier_currency: FilterValues,    
    origin_customer: FilterValues,
    origin_currency: FilterValues, 
    commission: number,
    supplier_commission: number   
}

const ValuesDetails: React.FC<{
    typeTrasnfer: 'deposit' | 'extraction' | undefined, 
    ammmountSign: string | undefined,  
    results: number | undefined, 
    resultSupplier: number | undefined, 
    suplierComission: number | undefined,
    ammount: number | undefined, 
    typeOfCalculation:'1' | '2' | '3'
}> = ({
    typeTrasnfer,
    ammmountSign,
    results,
    resultSupplier,
    suplierComission,
    ammount,
    typeOfCalculation
    
}) =>{
    const comissionSupplier = () =>{
        let commission = 0
        let total = 0
        switch(typeOfCalculation){
            case '1':
                if(typeTrasnfer ==='deposit' &&  ammount && suplierComission){
                    total =  (ammount*suplierComission)                  
                }else if(typeTrasnfer === 'extraction' && ammount && suplierComission){
                    total =  (ammount*suplierComission)
                }
                break;
            case '2':
                if(typeTrasnfer ==='deposit' && resultSupplier && suplierComission){
                    total = resultSupplier*suplierComission
                }else if(typeTrasnfer === 'extraction' && results && suplierComission){
                    total =  (results*suplierComission)
                }
                break;
            case '3':
                if(typeTrasnfer ==='deposit' && ammount && suplierComission){
                    total = ammount*suplierComission
                }else if(typeTrasnfer === 'extraction' && ammount && suplierComission){
                    total =  (ammount*suplierComission)
                }
                break;
        }
        commission = total / 100
        return commission
    }

    return(
        <Row    
            style={{
                minHeight: 121,
                display:'flex',
                flexDirection: 'column'
            }}>
             <Row
                style={{
                    marginBottom: 15, 
                    fontWeight: 700,
                    marginTop: 10
                }}
            >
                <span style={{marginRight:10}}>
                    {typeTrasnfer === 'deposit' && 'Depósito en cuenta proveedor:'}
                    {typeTrasnfer === 'extraction' && 'Extracción cuenta proveedor:'} 
                </span>
                <span>{ammmountSign && ammmountSign}</span>
                <span>{resultSupplier?.toLocaleString("es-AR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>  
            </Row>
             <Row
                style={{
                    marginBottom: 15, 
                    fontWeight: 700,
                    
                }}
            >
                <span style={{marginRight:10}}>{typeTrasnfer && `Comisión cliente`}</span>
                <span>{ammmountSign && ammmountSign}</span>
                <span>{resultSupplier && results && Math.abs(resultSupplier - results).toLocaleString("es-AR",{maximumFractionDigits:2, minimumFractionDigits:2}) }</span>  
            </Row> 
            <Row
                style={{
                    marginBottom: 15, 
                    fontWeight: 700,
                    
                }}
            >
                <span style={{marginRight:10}}>
                    {typeTrasnfer === 'deposit' && 'Credito en cuenta cliente:'}
                    {typeTrasnfer === 'extraction' && 'Débito en cuenta cliente:'} 
                </span>
                <span>{ammmountSign && ammmountSign}</span>
                <span>{typeTrasnfer && results?.toLocaleString("es-AR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>  
            </Row>                                           
            <Row
                style={{
                    marginBottom: 15, 
                    fontWeight: 700
                }}
            >
                <span style={{marginRight:10}}>
                    {typeTrasnfer && `Comisión de proveedor:`}
                </span>
                <span>{ammmountSign && ammmountSign}</span>
                <span>{typeTrasnfer && ammount && comissionSupplier().toLocaleString("es-AR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
            </Row> 
        </Row>
    )
}
const TotalComponent: React.FC<{
    checkoutsMovements:  OperationDataInSuppliers[],
    type: 'deposit' | 'extraction',
    sign: string  
}> = ({ checkoutsMovements, type, sign }) => {
    const total = checkoutsMovements?.reduce((acc, item) => {
        if(!item.approved_db && !item.deleted){
            if (type === 'deposit') {
                return acc + (item.debit || 0); // Suma "debit" si el tipo es "deposit"
            } else if (type === 'extraction') {
                return acc + (item.credit || 0); // Suma "credit" si el tipo es "extraction"
            }
        }        
        return acc;
    }, 0);

    return (
        <div>
            <p style={{ fontSize: 12, borderTop: '1px solid gray', paddingTop: 5}}><strong>Total: </strong>
                {' '}{sign}
                {/* hace referencia al depósito en el proveedro */}
                {type === 'deposit' && ' - ' } 
                {total.toLocaleString("es-AR", { maximumFractionDigits: 2, minimumFractionDigits: 2 })}</p>
        </div>
    );
};

export const TransfersSuppliers: React.FC<TransfersSuppliersProps> =({
    form,
})=>{

    //const {data: account} = useGetAllAccount()
    const [form_addMovements] = useForm()
    
    const {createOperation, editOperation, getOperation} = useOperations()
    const { data: cashs } = useGetCashDesk()
    const {getAccountsCurrencyAndCustomer} = useAccounts()  
    const { collapsedFilsters, setCollapsedFilters, setShowForms, showForms, dataTransactionsToForm, setDataTransactionsToForm
        //setSelectedRowId, 
        // selectedRowId 
    } = useContext(VariablesContext)
    const {setRowSelect} = useContext(OperationsContext)
    const { data: currency} = useGetCurrency()
    const { data: clients } = useGetAllClients()
    const { data: suppliers } = useGetAllClients({ is_supplier: true });
    const {userData} = useContext(UserContext)  
    const { data: operation_type } = useGetOperationType()
    const { Option } = Select;
    const mandatory = [
        {
            required: true,
            message:'Este campo es obligatorio'
        }
    ]
    
    const [loadingBtn, setLoadingBtn] = useState(false)
    const [approved, setaproved] = useState(false)
    const [selectedCurrency, setSelectedCurrency] = useState<{id: number, name: string, sign: string} | undefined>()
    const [spanError, setSpanError] = useState<string>() 
    const [secondSelectorList, setSecondSelectorList] = useState<AllClientsProps[]>([])
    const [secondCurrencySelectorList, setCurrencySecondSelectorList] = useState<CurrencyProps[]>([])
    const [ammmountSign, setAmmountSign] = useState<string>('')
    const [ammount, setAmmount] = useState<number>() 
    const [results, setResults] = useState<number>()
    const [resultSupplier, setResultsSupplier] = useState<number>()
    const [comission, setComission] = useState<number>(1.25)
    const [suplierComission, setSuplierComission] = useState<number>(0.5)
    const [typeTrasnfer, setTypeTransfer] = useState<'deposit' | 'extraction'>()
    const [transactionsData, setTransactionsData] = useState<Transaction>()
    const [typeOfCalculation, setTypeOfCalculation] = useState<'1' | '2' | '3'>('3')
    const [showAddMovements, setShowAddMovements] = useState<boolean>(false)
    const [values, setValues] = useState<OperationDataInSuppliers | undefined>()
    const [checkoutsMovements, setCheckoutsMovements] = useState<OperationDataInSuppliers[] | undefined>()
    const [disabledForm, setDisableForm] = useState<{
        disable: boolean,
        approved: boolean,
        deleted: boolean,
        operationNumber: number | undefined,
        whitCheckouts: boolean
    }>({
        disable: true,
        approved: false,
        deleted: false,
        whitCheckouts: false,
        operationNumber: undefined
    })

    const options:  { label: string; value: string }[]  = [
        { label: 'Ingresar total', value: '1', },
        { label: 'Comisión sobre bruto', value: '2' },
        { label: 'Comisión sobre neto', value: '3' },
    ];


    useEffect(()=>{
        form.resetFields()
    },[])

    useEffect(()=>{
        if( typeTrasnfer &&
            ammount !== undefined && ammount !== null &&
            comission !== undefined && comission !== null){
                switch(typeOfCalculation){
                    case '1':  //Total    
                        if(typeTrasnfer === 'extraction') {
                            setResults(ammount)
                            setResultsSupplier((ammount-(ammount*(comission/100))))
                        }else if(typeTrasnfer === 'deposit'){
                            setResults((ammount-(ammount*(comission/100))))
                            setResultsSupplier(ammount)
                        }                              
                        break;
                    case '2': //Sobre bruto
                        if(typeTrasnfer === 'extraction'){
                            setResults((100*ammount)/(100-comission))
                            setResultsSupplier(ammount)
                        }else if(typeTrasnfer === 'deposit'){
                            setResults(ammount)
                            setResultsSupplier((100*ammount)/(100-comission))
                        }                                                                      
                        break;
                    case '3': //Sobre neto
                        if(typeTrasnfer === 'extraction'){
                            setResults((ammount*(1+comission/100)))    
                            setResultsSupplier(ammount)
                        }else{
                            setResults(ammount)    
                            setResultsSupplier((ammount*(1+comission/100)))
                        }                                                                    
                        break;
                    default:                        
                        break;
                }
                    
        }
    },[comission, ammount, typeTrasnfer, typeOfCalculation])


    useEffect(() => {
     
       if(dataTransactionsToForm){
            uploadForm(dataTransactionsToForm)            
        }else{
            setDisableForm({
                disable: false,
                approved: false,
                deleted: false,
                whitCheckouts: false,
                operationNumber: undefined
            })
            form.resetFields(undefined) 
            setSelectedCurrency(undefined)
            setAmmount(undefined)
        }        
    }, []);

    const loadCheckoutMovement = (movements: Transaction[]) =>{
        let data: OperationDataInSuppliers[] = []
        movements.map((item, index)=>{
            let type_id: number | undefined
            let customer_id: number | undefined
            let currency_id: number | undefined
            switch(item.type.id){
                case 1: // Depósito
                case 3:
                    type_id = 1
                    customer_id = item.destination_account.customer.id
                    currency_id = item.destination_account.currency.id
                    break;
                case 2: //Extracción
                case 4:
                    type_id = 2
                    customer_id = item.origin_account.customer.id
                    currency_id = item.origin_account.currency.id
                    break;
            }
            if (type_id && customer_id && currency_id){                 
                data.push({
                    description: item.description,  
                    type_id: type_id,  
                    customer_id: customer_id,  
                    approved: item.approved,  
                    commission: item.commission || undefined,  
                    debit: item.debit ? Number(item.debit) : undefined,  
                    credit: item.credit ? Number(item.credit) : undefined,  
                    destination_checkout_id: item.destination_checkout?.id || undefined,  
                    origin_checkout_id: item.origin_checkout?.id || undefined,
                    transfer_costs: item.transfer_costs || undefined,  
                    client_pays_costs: item.client_pays_costs || undefined,  
                    related_load_operation_id: item.related_load_operation_id || undefined,  
                    currency: currency_id,  
                    id: item.id,  
                    deleted: item.deleted,  
                    approved_db: item.approved,
                    key: index,
                    operation_id: item.operation_id
                })                                
            }
            setCheckoutsMovements(data)
        })
    }

    const uploadForm = async(response: Transaction) =>{
        if(response){          
            setDisableForm({
                disable: response.approved || response.deleted ? true : false,
                approved: response.approved || false,
                deleted: response.deleted || false,
                whitCheckouts: response.related_load_operations && response.related_load_operations.length > 0 ? true : false,
                operationNumber: response.operation_id
            })  
            setTransactionsData(response)
            setaproved(response.approved)      
            if(response.related_load_operations){
                loadCheckoutMovement(response.related_load_operations)
            }
            
            const isType10 = response.type.id === 10; //es depósito en proveedor
            const customerAccount = isType10 ? response.destination_account : response.origin_account;
            const supplierAccount = isType10 ? response.origin_account: response.destination_account;
            let total = response.type.id === 10 ? response.debit : response.credit
            let ammount  
            
            if(response.customer_input_type){
                switch(response.customer_input_type.toString()){
                    case '1':
                        setTypeOfCalculation('1')     
                        if(!isType10 && response.commission){
                            ammount = (total*100) / (100 - response.commission) 
                        }else{
                            ammount = total 
                        }                  
                        break;
                    case '2':                        
                        setTypeOfCalculation('2')
                        if(isType10 && response.commission){
                            ammount =  Number((total - ((response.commission/100)*total) ).toFixed())
                        }else{
                            ammount = total
                        }                        
                        break;
                    case '3':                        
                        setTypeOfCalculation('3')
                        if(isType10){
                            ammount = response.commission ? total / (1 + (response.commission / 100)) : total
                        }else{
                            ammount = total
                        }                        
                        break;
                    default:
                        break;
                }
            }
            
            setAmmount(ammount)
            form.setFieldsValue({
                supplier: {
                    label: supplierAccount?.customer?.first_name + ' ' + supplierAccount?.customer.last_name,
                    value: supplierAccount.customer?.first_name + ' ' + supplierAccount?.customer.last_name,
                    key: supplierAccount.customer.id,
                },
                origin_customer: {
                    label: customerAccount?.customer.first_name + ' ' + customerAccount?.customer.last_name,
                    value: customerAccount?.customer.first_name + ' ' + customerAccount?.customer.last_name,
                    key: customerAccount?.customer.id,
                },
                origin_currency: {
                    label: response.origin_account.currency.name,
                    value: response.origin_account.currency.name,
                    key: response.origin_account.currency.id
                },
                operation_type:{
                    label: response.type.name,
                    value: response.type.name,
                    key: response.type.id,
                },
                commission: response.commission,
                supplier_commission:response.supplier_commission,
                ammount: ammount,
                description: response.description
            });  
         
            if(response.type.id === 10){
                setTypeTransfer('deposit')
            }else if(response.type.id === 11){
                setTypeTransfer('extraction')
            }
            setAmmountSign(customerAccount.currency.sign)
            if(response.commission){
                setComission(response.commission)
            }
            if(response.supplier_commission){
                setSuplierComission(response.supplier_commission)
            }

            setSelectedCurrency({
                name: response.origin_account.currency.name,
                id: response.origin_account.currency.id,
                sign: response.origin_account.currency.sign
            })                
        }  
    }

    const checkBalance = async(user_id: number, ammount: number) =>{
        if(selectedCurrency){
            const balanceData = await getAccountsCurrencyAndCustomer(user_id, +selectedCurrency.id) //consulto el balance de cliente
            if(balanceData && balanceData){
               // setBalance( balanceData)
                if(ammount > balanceData.balance ){            
                    let value = new Intl.NumberFormat('es-AR', { style: 'decimal', minimumFractionDigits: 2 }).format(balanceData.balance)
                    setSpanError('Notificación: El monto a transferir supera el monto de cuenta: ' + selectedCurrency?.sign + ' ' + value  )  
                }else{
                    setSpanError('')
                }
            }                    
        }         
    }

    const handleCancel =()=>{
        setShowForms(Object.fromEntries(Object.keys(showForms).map(key => [key, false])))// pone todos en false
        if(dataTransactionsToForm){
            setDataTransactionsToForm(undefined)
        }        
        setTransactionsData(undefined)
        setRowSelect(undefined)
    }

    const changeTransferer = (e: {
        key: string,
    } ) =>{
        let typeOperations: 'deposit' | 'extraction' | undefined
        switch(e.key){
            case '10':
                typeOperations = 'deposit'
                break;
            case '11':
                typeOperations = 'extraction'
                break;
            default:
                typeOperations = undefined
        }
        setTypeTransfer(typeOperations)
        setCheckoutsMovements(undefined)
          
    }

    const onChangeFirstClient = (e: FilterValues) =>{
        if(suppliers){
            let list = suppliers?.filter((x)=> 
                +e.key !== x.id)
            setSecondSelectorList(list)
            form.resetFields(['destination_customer'])

        }        
    }

    const onChangeFirstCurrency = (e: FilterValues, values: { sign: string } | { sign: string }[]) =>{
        const signValue = Array.isArray(values) ? values[0]?.sign : values.sign;
        if(currency){
            let list = currency?.filter((x)=> 
                +e.key===x.id)
            setCurrencySecondSelectorList(list)
            setAmmountSign(signValue)
        }        
        setSelectedCurrency({
            id: e.key, 
            name: e.label,
            sign: signValue})
    }

    const onChangeAmmount = (e: any) =>{
        setAmmount(Number(e))       
    }  

    const onChangeapproved: CheckboxProps['onChange'] = async (e) => {
        setaproved(e.target.checked); 
    };

    const hanldeChangeComision = (value: string | null) =>{
        if(value !== undefined && value !== null){
            setComission(Number(value))
        }
    }

    const hanldeChangeSuplierComision = (value: string | null) =>{
        if(value !== undefined &&  value !== null){
            setSuplierComission(Number(value))
        }
    }

    const confirmSave = async(operationData: OperationTypeProps) =>{
        let newData
        let doNotUpdate: boolean =  false // Confirmo si tiene que actualizar datos en tabla, como hago dos operaciones, actualizo en la última operacion guardada
  
        if(checkoutsMovements && checkoutsMovements?.length > 0){
            for (const x of checkoutsMovements ?? []) {
                if (!x.approved_db || !x.deleted) {
                    doNotUpdate = true
                }
            }
        }
        if(dataTransactionsToForm){
            newData = await editOperation(handleCancel, dataTransactionsToForm.id.toString(), operationData, doNotUpdate )                        
        }else{
            newData = await createOperation(handleCancel, operationData, doNotUpdate)
        }  
        if(newData && newData !== 'error'){
            saveCheckoutMovements(newData)
        }                      
        setCollapsedFilters(!collapsedFilsters)
        setLoadingBtn(false)  
    }

    const saveCheckoutMovements = (response: Transaction)=>{
        let newData
        let enabled: OperationDataInSuppliers[] = []
        checkoutsMovements?.forEach((item)=>{
            if(!item.approved_db || !item.deleted){
                enabled.push(item)
            }
        })
        enabled?.map(async(item, index)=>{
            item.related_load_operation_id = response.id
            let doNotUpload = (index == enabled.length - 1) ? false : true
            if(item.id){
                newData = await editOperation(handleCancel, item.id.toString(), item, doNotUpload)                            
            }else{
                newData = await createOperation(handleCancel, item, doNotUpload)
            }
                        
        })        
    }

    const openDepositExtraction = () =>{
              
        const valuesForm: ValuesForm = form.getFieldsValue();
        let customer = valuesForm?.origin_customer        
        let debitOrCredit: number | undefined
        let operation_type =  (Number(valuesForm?.operation_type?.key) === 10) 
            ? 2 
            : (Number(valuesForm?.operation_type?.key) === 11)
                ? 1
                : undefined 
        
        switch(typeOfCalculation){
            case '1': //ingresar total
                if(typeTrasnfer === 'extraction'){
                    debitOrCredit = form.getFieldValue('ammount') //es el valor a debitr en una caja
                }else{
                    debitOrCredit = results
                }                
                break;
            case '2': //Comisión sobre bruto
                debitOrCredit = results
                break;
            case '3': //Comisión sobre neto
                debitOrCredit = results// form.getFieldValue('ammount')
                break;
            default:
                break
        }

        if(operation_type &&  customer?.key && selectedCurrency){
            setValues({
                type_id: operation_type,
                customer_id: customer.key,
                //user_id: userData.id,
                approved: false,
                commission: undefined,     
                debit: typeTrasnfer === 'deposit' ? debitOrCredit : undefined, //si es depósito en proveedor, es débito en caja agencia
                credit: typeTrasnfer === 'extraction' ? debitOrCredit : undefined, //si es extracción en proveedor, es crédito en caja agencia
                destination_checkout_id: undefined,    
                origin_checkout_id: undefined,
                transfer_costs: undefined,
                client_pays_costs: false,
                description: '',
                currency: selectedCurrency.id,
                operation_id: undefined
            })
            setShowAddMovements(!showAddMovements);
        }
             
        
    }

    const handleSave = async (e: ValuesForm)=>{
        if(e.supplier.key===e.origin_customer.key){
            notification.error({
                message: 'Error', 
                description:
                  'Cliente y proveedor deben ser distintos', 
                placement: 'top'
            })
            return   

        }
        let ammount: number | undefined

        switch(typeOfCalculation){
            case '1':                
            case '3':
                ammount = e.ammount
                break;
            case '2':
                if(Number(e.operation_type.key) === 10){
                    ammount = resultSupplier
                }else if(Number(e.operation_type.key) === 11){
                    ammount = results
                }                
                break;
            default:
                break
        }
        //setLoadingBtn(true)
        let operationData: OperationTypeProps | undefined
        if(userData){
            operationData = {
                description: e.description,
                type_id: e.operation_type.key,
                currency_id: e.origin_currency.key,
                user_id: userData.id,
                debit: Number(e?.operation_type?.key) == 11 ? ammount : undefined,
                credit: Number(e?.operation_type?.key) == 10 ? ammount : undefined,
                approved: approved, 
                customer_id: e.origin_customer.key, 
                supplier_id: e.supplier.key, 
                commission: e.commission, 
                supplier_commission: e.supplier_commission,
                customer_input_type: typeOfCalculation !== undefined ? Number(typeOfCalculation) : undefined
            }              
        }    
        
        if(operationData){
            let sign = currency?.find((x)=> x.id === Number(e.origin_currency.key))?.sign || ''
            Modal.confirm({
                title: 'Confirmar operación',
                okText: 'Confirmar',
                cancelText: 'Cancelar',
                onOk:()=> {
                    if(operationData){
                        confirmSave(operationData)
                    }                    
                },
                content: (
                    <div>
                        <p><strong>{e.operation_type.label}</strong></p>
                        {e.origin_customer.label && <p><strong>Cliente: </strong> {e.origin_customer.label}</p>}    
                        {e.supplier.label && <p><strong>Proveedor: </strong> {e.supplier.label}</p>}                                      
                        {e.origin_currency.key && <p><strong>{typeTrasnfer === 'deposit' ? 'Depósito' : 'Extracción' } en proveedor: </strong>{sign} {resultSupplier?.toLocaleString("es-AR",{maximumFractionDigits:2, minimumFractionDigits:2})}</p>}
                        {results && resultSupplier && <p><strong>Comisión cliente: </strong>{Math.abs(resultSupplier - results).toLocaleString("es-AR",{maximumFractionDigits:2, minimumFractionDigits:2}) } </p>}
                        {results && 
                            <p>
                                <strong>{`${e.operation_type.key.toString() === '11' ? 'Débito': 'Crédito'} cuenta cliente:`} </strong>
                                {sign} {results.toLocaleString("es-AR",{maximumFractionDigits:2, minimumFractionDigits:2})}
                            </p>
                        } 
                        {  operationData.supplier_commission !== undefined &&  operationData.supplier_commission > 0 && <p><strong>Comisión proveedor: </strong>{operationData.supplier_commission } % ({sign}{ammount && suplierComission &&  ((ammount*suplierComission)/100)?.toLocaleString("es-AR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })})</p>}                       
                        <p>
                            <strong>Estado: </strong>
                            <strong style={{ color: operationData.approved ? 'green' : 'orange' }}>
                                {operationData.approved ? 'Aprobado' : 'Sin aprobar'}
                            </strong>
                        </p> 
                        
                        {   checkoutsMovements && checkoutsMovements.length > 0 && typeTrasnfer &&
                            <>
                                <div style={{borderTop: '1px solid gray', fontSize: 12, gap: 4}}>
                                    <p style={{margin: '5px 0px 0px'}}><strong>Cajas:</strong></p>
                                    {checkoutsMovements?.map((item)=>{
                                        if(!item.deleted){
                                            let checkout_id = item.destination_checkout_id || item.origin_checkout_id
                                            let checkout_data = checkout_id && cashs.find((x)=>x.id == checkout_id)
                                            return(
                                                <div style={{display: 'flex', justifyContent: 'space-between'}}>
                                                    <p style={{margin: 0}}><strong>{checkout_data && `${checkout_data.name} (${checkout_data.branch.name}): `}</strong>
                                                        {item.type_id === 2 && '-' }
                                                        {sign} { item.type_id === 2 ? item.debit : item.credit}
                                                    </p>
                                                    <p style={{margin: 0}}>                                                   
                                                        <strong style={{ color: item.approved ? 'green' : 'orange' }}>
                                                            {item.approved ? 'Aprobado' : 'Sin aprobar'}
                                                        </strong>
                                                    </p>
                                                </div>                                       
                                            )
                                        }
                                    })}                           
                                </div> 
                                <TotalComponent 
                                    checkoutsMovements={checkoutsMovements} type={typeTrasnfer}
                                    sign={sign}
                                />
                            </>                              
                        }                                                                                                              
                    </div>
                ),
            });  
        }            
    }   

    const onChangeRadio = (e: RadioChangeEvent) =>{
        setTypeOfCalculation(e.target.value)
    }
    
    const changePoint = (e:  React.KeyboardEvent<HTMLInputElement>)=>{
        const input = e.currentTarget as HTMLInputElement;
        const start = input.selectionStart ?? 0;
        const end = input.selectionEnd ?? 0;
        let newValue = input.value

        if (e.key === '.' && !e.shiftKey) {
            e.preventDefault();
            if (!input.value.includes(',')) {
                newValue = input.value.substring(0, start) + ',' + input.value.substring(end);
                input.value = newValue;
                input.setSelectionRange(start + 1, start + 1);
                input.dispatchEvent(new Event('input', { bubbles: true }));
            }
        }else if (e.key === ',') {
            e.preventDefault();
            if (!input.value.includes(',')) {
                newValue = input.value.substring(0, start) + ',' + input.value.substring(end);
                input.value = newValue;
                input.setSelectionRange(start + 1, start + 1);
                input.dispatchEvent(new Event('input', { bubbles: true }));
            }
        }
    }

    return(
        <div>
            {showAddMovements && 
                <DepositExtractionForm 
                    form={form_addMovements} 
                    showAddMovements={showAddMovements}
                    setShowAddMovements={setShowAddMovements}
                    checkoutsMovements={checkoutsMovements}
                    setCheckoutsMovements={setCheckoutsMovements}
                    supplierTransactions={transactionsData ? transactionsData : undefined}
                    values={values}                    
            />}
            <Modal
                width={1000}
                style={{ 
                    top: 10,
                }}
                title= {
                    <ModalTitle
                        title={'Depósito / Extracción: Cliente - Proveedor'} 
                        isApproved={disabledForm.approved}
                        isDeleted={disabledForm.deleted}
                        operationNumber={disabledForm.operationNumber}
                    />
                }
                footer={transactionsData?.approved ? null : undefined}
                open={showForms.transfer_to_suppliers}
                onCancel={handleCancel}  
                //confirmLoading={loadingBtn}                   
                okText="Guardar"
                cancelText="Cancelar" 
                onOk={()=>form.submit()}
            >
                {!disabledForm.disable && <NewCustomer justify={"end"} positions= {'leftTop'} />}
                <Form
                    form={form}
                    id='form_deposit_extraction'
                    onFinish={handleSave}
                    layout="vertical"                    
                >   
                    <Row
                        gutter={20}
                        style={{
                            marginTop: 10
                        }}
                    >
                        <Col 
                            span={12}                            
                        >
                            <Form.Item
                                label='Tipo de operación'
                                name='operation_type'                
                                rules={mandatory}
                            >                        
                                <Select
                                    disabled={disabledForm.disable || disabledForm.whitCheckouts}
                                    labelInValue
                                    placeholder="Seleccione el tipo de movimiento"   
                                    onChange={changeTransferer}                         
                                >
                                    {operation_type &&  operation_type.filter(item => [10, 11].includes(item.id)).map((item) => (
                                        <Option value={item.name} key={item.id} >
                                            {item.name}
                                        </Option>
                                    ))} 
                                </Select>
                            </Form.Item>  
                            <Row
                            >
                                <Col span={14} >
                                    <Form.Item
                                        label='Cliente'
                                        name='origin_customer'
                                        rules={mandatory}
                                    >   
                                        <Select      
                                            disabled={disabledForm.disable || disabledForm.whitCheckouts}                     
                                            labelInValue  
                                            loading={!clients }
                                            placeholder={!clients ? 'Cargando campos...' : 'Cliente'}      
                                            style={{minWidth: '200px'}} 
                                            showSearch   
                                            onChange={onChangeFirstClient}                                 
                                        >
                                            {clients && clients.map((item) => (
                                                <Option value={item.first_name + ' ' + item.last_name} key={item.id} >
                                                    {item.first_name + ' ' + item.last_name}
                                                </Option>
                                            ))} 
                                        </Select>

                                    </Form.Item>
                                </Col>
                                <Col span={10}>
                                    <Form.Item
                                        label='Moneda cuenta de origen'
                                        name='origin_currency'                         
                                        rules={mandatory}                                                           
                                    >
                                        <Select                                
                                            disabled={disabledForm.disable || disabledForm.whitCheckouts}
                                            labelInValue     
                                            placeholder='Moneda de cuenta' 
                                            onChange={onChangeFirstCurrency}                                                                  
                                        >
                                            {currency && currency.map((item) => (
                                                <Option 
                                                    value={item.name} 
                                                    key={item.id}
                                                    sign={item.sign} >
                                                {item.name}
                                                </Option>
                                            ))} 
                                        </Select>
                                    </Form.Item>
                                </Col>                                                                               
                            </Row> 
                            <Row>
                                <Col span={14}>
                                    <Form.Item
                                        label='Proveedor'
                                        name='supplier'
                                        rules={mandatory}
                                    >   
                                        <Select   
                                            disabled={disabledForm.disable}                        
                                            labelInValue  
                                            loading={!suppliers }
                                            placeholder={!suppliers ? 'Cargando campos...' : 'Proveedor'}      
                                            style={{minWidth: '200px'}} 
                                            showSearch   
                                            // onChange={(e: FilterValues)=>setSelectedSupplier({id: e.key, name: e.label})}                              
                                        >
                                            {secondSelectorList && secondSelectorList.map((item) => (
                                                <Option value={item.first_name + ' ' + item.last_name} key={item.id} >
                                                    {item.first_name + ' ' + item.last_name}
                                                </Option>
                                            ))} 
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col span={10}>
                                    <Form.Item
                                        label='Moneda cuenta de destino'
                                        name='origin_currency'                         
                                        rules={mandatory}                       
                                    
                                    >
                                        <Select
                                            labelInValue     
                                            placeholder='Moneda de cuenta'  
                                            disabled={true}                                                                                                    
                                        >
                                            {secondCurrencySelectorList && secondCurrencySelectorList.map((item) => (
                                                <Option 
                                                    value={item.name} 
                                                    key={item.id} >
                                                {item.name}
                                                </Option>
                                            ))} 
                                        </Select>
                                    </Form.Item>                        
                                </Col>                                               
                            </Row> 
                            {!disabledForm.disable &&
                                <Button
                                        type='primary'
                                        disabled= {(!!typeTrasnfer && form.getFieldValue('origin_customer') &&  selectedCurrency ? false : true )}
                                        onClick={openDepositExtraction}
                                    >
                                    Agregar movimiento en caja
                                </Button>
                            }
                            <Row
                                style={{
                                    // width: '100%',
                                    display:' flex',
                                    justifyContent: 'start',
                                    flexDirection: 'column',
                                    marginTop: 10
                                }}
                            >                                
                                {checkoutsMovements?.map((item, index)=>{
                                    let checkoutSelected = item.destination_checkout_id || item.origin_checkout_id
                                    let cash = cashs.find((x)=>x.id ===  checkoutSelected)
                                    let ammount = item.type_id == 1 ? item?.credit : item?.debit
                                    let showTarget = true
                                    if(item.deleted && !item.approved_db){
                                        showTarget = false
                                    }
                                    if(showTarget){
                                        return(
                                            <Row
                                                key={index}
                                                style={{
                                                    backgroundColor: 'rgb(241, 241, 241)',
                                                    width: '100%',
                                                    borderRadius: '2px',
                                                    padding: '2px 14px',
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    marginBottom: 5,
                                                    color: item.approved_db ? 'gray' : 'black',
                                                    cursor:  'pointer'
                                                }}
                                                onClick={()=>{
                                                    item.key = index
                                                    setValues(item)
                                                    setShowAddMovements(true)
                                                                                                        
                                                }}                                                
                                            >
                                                <Col>{cash?.name} ({cash?.branch.name})</Col>   
                                                <Col>
                                                    {item?.type_id === 2 && `- `}{cash?.currency.sign} {ammount && (ammount).toLocaleString('es-AR',{minimumFractionDigits:2, maximumFractionDigits: 2})}
                                                    {(item.approved) && <CheckOutlined style={{color:"rgb(32, 178, 170)", marginLeft: 5}}/>}
                                                    {(item.deleted) && <CloseOutlined style={{color:"red", marginLeft: 5}}/>}
                                                </Col>

                                            </Row>
                                        )
                                    }                                    
                                    })}
                            </Row>
                        </Col>
                        <Col
                            span={12}    
                        >                                    
                            <Radio.Group
                                style={{
                                    justifyContent: 'space-between',
                                    display: 'flex',
                                    padding: '34px 10px 30px',
                                }}
                                value={typeOfCalculation}
                                onChange={onChangeRadio}
                                disabled={disabledForm.disable}
                                >
                                {options.map((option) => (
                                    <Tooltip 
                                        overlayClassName="ts-tooltip"
                                        key={option.value} 
                                        placement='topRight'
                                        title={ 
                                            typeTrasnfer
                                            ? toolpipsOptions[typeTrasnfer][option.value as '1' | '2' | '3']
                                            : ''
                                        }
                                    >
                                        <Radio value={option.value}>{option.label}</Radio>
                                    </Tooltip>
                                ))}
                            </Radio.Group>                                            
                            <Form.Item
                                label='Monto'
                                name='ammount'
                                rules={mandatory}
                            >
                                <InputNumber
                                    disabled={disabledForm.disable}
                                    style={{width: '100%'}}
                                    placeholder="Monto"
                                    onChange={onChangeAmmount}
                                    addonBefore={ammmountSign ? ammmountSign : ' ¤ '}                                    
                                    formatter={value =>
                                    value
                                        ? new Intl.NumberFormat('es-AR', {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 20
                                        }).format(Number(value))
                                        : ''
                                }
                                    onKeyDown={changePoint}
                                    parser={value => value?.replace(/\./g, '').replace(',', '.') || ''}
                                    stringMode 
                                />
                            </Form.Item>  
                            <Row                            
                                justify='space-between'                            
                            >
                                <Form.Item
                                    label='Comisión a cliente'
                                    name='commission'
                                    initialValue={comission}
                                    rules={[
                                        {
                                            required: true,
                                            message:'Este campo es obligatorio'
                                        }
                                    ]}
                                >
                                    <InputNumber                            
                                        disabled={disabledForm.disable}
                                        style={{width: '100%'}}
                                        placeholder="Comisión"                            
                                        addonBefore='%'
                                        onChange={hanldeChangeComision}
                                        formatter={value =>
                                        value
                                            ? new Intl.NumberFormat('es-AR', {
                                                minimumFractionDigits: 0,
                                                maximumFractionDigits: 20
                                            }).format(Number(value))
                                            : ''
                                        }
                                        onKeyDown={changePoint}
                                        parser={value => value?.replace(/\./g, '').replace(',', '.') || ''}
                                        stringMode 
                                    />
                                </Form.Item>   
                                <Form.Item
                                    label='comisión de proveedor'
                                    name='supplier_commission'
                                    initialValue={suplierComission}
                                    rules={[
                                        {
                                            required: true,
                                            message:'Este campo es obligatorio'
                                        }
                                    ]}
                                >
                                    <InputNumber
                                        disabled={disabledForm.disable}
                                        onChange={hanldeChangeSuplierComision}
                                        style={{width: '100%'}}
                                        placeholder="Comisión"
                                        addonBefore='%'
                                        formatter={value =>
                                        value
                                            ? new Intl.NumberFormat('es-AR', {
                                                minimumFractionDigits: 0,
                                                maximumFractionDigits: 20
                                            }).format(Number(value))
                                            : ''
                                        }
                                        onKeyDown={changePoint}
                                        parser={value => value?.replace(/\./g, '').replace(',', '.') || ''}
                                        stringMode 
                                    />
                                </Form.Item>
                            </Row> 
                            <ValuesDetails 
                                typeTrasnfer={typeTrasnfer} 
                                ammmountSign={ammmountSign} 
                                results={results}
                                resultSupplier={resultSupplier}   
                                suplierComission={suplierComission} 
                                ammount={ammount}
                                typeOfCalculation={typeOfCalculation}
                            />                                                                                                                                
                        </Col>                                                
                    </Row>                                                                                 
                    <Checkbox
                        style={{marginBottom: 10}}
                        disabled={transactionsData?.approved}
                        checked={approved}
                        onChange={onChangeapproved}
                    >
                        Aprobado (Operación cliente - proveedor)
                    </Checkbox>
                    <Form.Item
                        label='Descripción'
                        name='description'
                    >
                        <Input
                            disabled={disabledForm.disable}
                            placeholder="Comentario"
                        />
                    </Form.Item>  
                    <span style={{color: 'red'}}>{spanError && spanError} </span>           
                </Form>
                
            </Modal>
        </div>
    )
}

export default TransfersSuppliers;